export enum KnownProvenance {
  None = 'none' /** Provenance value given for entities that were not provisioned */,
  API = 'api',
  File = 'file',
  ConvertedPrometheus = 'converted_prometheus',
}
